import { Users } from "@prisma/client";
import { makeAutoObservable } from "mobx";

class User {
  isLoading = true;
  id = null;
  picture = null;
  firstname = null;
  lastname = null;
  email = null;
  defaultStoreSlug = null;

  constructor() {
    makeAutoObservable(this);
  }

  setIsLoading(isLoading: boolean) {
    this.isLoading = isLoading;
  }

  setValue(user: Users & { defaultStore: { slug: string } }) {
    this.picture = user.picture;
    this.email = user.email;
    this.id = user.id;
    this.firstname = user.firstname;
    this.lastname = user.lastname;
    this.defaultStoreSlug = user?.defaultStore?.slug;
  }
}

const user = new User();

export default user;
